import { render } from "./CalculadoraCreditoComponent.vue?vue&type=template&id=5fc5e72e&scoped=true"
import script from "./CalculadoraCreditoComponent.vue?vue&type=script&lang=js"
export * from "./CalculadoraCreditoComponent.vue?vue&type=script&lang=js"

import "./CalculadoraCreditoComponent.vue?vue&type=style&index=0&id=5fc5e72e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc5e72e"]])

export default __exports__